<template>
  <div>
    <el-table  height="226.5px" stripe :header-cell-style="getCellClass" row-key="d_id" ref="multipleTable"
               :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
               @sort-change="sortChange" :data="tableData">
      <el-table-column prop="taskName" label="任务名称" min-width="160" fixed="left" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="table_text_click_new"  @click="showDialogVisible('task', scope.row)">【{{scope.row.taskId}}】{{scope.row.taskName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="taskStatus" label="状态" width="80"  fixed="left" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="demandName" label="需求名称" width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="table_text_click_new" @click="showDialogVisible('demand', scope.row)">【{{scope.row.demandId}}】{{scope.row.demandName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="module" label="系统" width="80" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="pm" label="产品" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.pm.nameZh?scope.row.pm.nameZh:''}} {{scope.row.pm.nameEn?'('+scope.row.pm.nameEn+')':''}} </span>
        </template>
      </el-table-column>
      <el-table-column prop="reviewer" label="技术负责人" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.reviewer.nameZh?scope.row.reviewer.nameZh:''}} {{scope.row.reviewer.nameEn?'('+scope.row.reviewer.nameEn+')':''}} </span>
        </template>
      </el-table-column>
      <el-table-column prop="deployDate" label="计划完成日期" width="120" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <Demand v-if="dialogVisible.demand" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.demand'
            :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" :tabid="tabid"/>
    <Task v-if="dialogVisible.task" :back="back" :dialogVisible='dialogVisible.task' :hideDialogVisible="hideDialogVisible"
          :formInfo="checkedInfo" :tabid="tabid"/>
    <ToDevelop v-if="dialogVisible.toDevelop" :dialogVisible='dialogVisible.toDevelop'
               :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <Developing v-if="dialogVisible.developing" :dialogVisible='dialogVisible.developing'
                :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <ToTest v-if="dialogVisible.toTest" :dialogVisible='dialogVisible.toTest' :hideDialogVisible="hideDialogVisible"
            :formInfo="checkedInfo" />
    <TestEnvTesting v-if="dialogVisible.testEnvTesting" :dialogVisible='dialogVisible.testEnvTesting'
                    :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <PreEnvTesting v-if="dialogVisible.preEnvTesting" :dialogVisible='dialogVisible.preEnvTesting'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <UatTesting v-if="dialogVisible.uatTesting" :dialogVisible='dialogVisible.uatTesting'
                :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <ToRelease v-if="dialogVisible.toRelease" :dialogVisible='dialogVisible.toRelease'
               :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <ProEnvTesting v-if="dialogVisible.proEnvTesting" :dialogVisible='dialogVisible.proEnvTesting'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <Online v-if="dialogVisible.online" :dialogVisible='dialogVisible.online' :hideDialogVisible="hideDialogVisible"
            :formInfo="checkedInfo" />
    <TestTask v-if="dialogVisible.addTest" :dialogVisible='dialogVisible.addTest' :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"/>

    <CreateProject v-if="dialogVisible.project" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.project'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
  </div>
</template>
<script>
import { Demand, Task, ToDevelop, Developing, ToTest, TestEnvTesting, PreEnvTesting, UatTesting, ToRelease, ProEnvTesting, Online } from '@/views/tops/devOps/producerSpace/components'
import {postDevOpsSpaceDevTaskApi} from "@/server/tops/devOps";
import CreateProject from "@/views/tops/devOps/producerSpace/components/createProject.vue";
import TestTask from "@/views/tops/devOps/producerSpace/components/testTask.vue";
export default {
  components: {
    TestTask,
    CreateProject,
    Demand, Task, ToDevelop, Developing, ToTest, TestEnvTesting, PreEnvTesting, UatTesting, ToRelease, ProEnvTesting, Online},
  props: {
    tableData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 弹出层部分
      dialogVisible: {
        demand: false,
        task: false,
        toDevelop: false,
        developing: false,
        toTest: false,
        testEnvTesting: false,
        preEnvTesting: false,
        uatTesting: false,
        toRelease: false,
        proEnvTesting: false,
        online: false,
        addBug: false,
        project: false,
        report: false,
        record: false,
      },
      // 选中信息
      checkedInfo: {},
      back : '',
    }
  },
  async mounted() {
  },
  created() {
  },
  methods:{
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;font-size:12px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    // 弹出模板
    async showDialogVisible(type, row , back = '') {
      let newRow = {...row};
      if(type === 'task'){
        if(!row.taskId){
          newRow = {...row,taskId:row.id}
        }else{
          newRow = {...row,taskId:row.taskId}
        }
      }
      if(type === 'project'){
        newRow = {name : row.projectName, id: row.projectId}
      }
      if(type === 'demand'){
        newRow = {name : row.demandName, id: row.demandId}
      }
      if (type === 'releaseing') {
        return;
      }
    //  await this.hideDialogVisible('', false)
      this.checkedInfo = newRow;
      this.dialogVisible[type] = true;
      this.back = back;
    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      let pid = '';
      if(nextStep === 'demand'){
        pid = this.checkedInfo.id;
      }

      if (nextStep && (typeof(nextStep) === 'string')) {
        /*const params = nextStep === 'demand' ? { title: this.checkedInfo?.id} : { task_title: this.checkedInfo?.taskInfo?.id }
        const ret = await postDevOpsSpaceDevTaskApi(params);
        const tableData = this.formatTableData(ret.data) || [];
        this.checkedInfo = tableData[0];
        this.checkedInfo.next = (nextStep === 'demand')
        if(nextStep === 'demand'){
          this.checkedInfo = {id:pid};
        }*/
        this.$nextTick(() => {
          this.dialogVisible[nextStep] = true;
        })
      } else {
       // search && await this.formSearch()
      }
      this.$emit('changeTask');
    },
  },
}
</script>
